(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.factory('Weekscheme', ['SharedAgendaService', WeekschemeFactoryFn]);

    // weekscheme object model
    function WeekschemeFactoryFn(SharedAgendaService) {

        var Weekscheme = function () {

            // default values
            this.id = 0;
            this.fK_User = 0;
            this.activationDate = null;
            this.isIndividual = false;
            this.startingWeekday = 0;
            this.sortOrder = 0;
            this.startDate = null;
            this.endDate = null;
            this.caption = null;
            this.dayInMonth = 0;
            this.weekInMonth = 0;

            // list of day schemes
            this.daySchemes = [];

        };

        // extend
        Weekscheme.prototype.extend = function (object) {
            var self = this;
            angular.extend(self, object);

            // set current user id
            self.fK_User = SharedAgendaService.currentUser().id;
        };

        // prepare for save
        Weekscheme.prototype.prepareForSave = function () {            
            var self = this;

            self.dayInMonth = self.dayInMonth && self.dayInMonth > 0 ? self.dayInMonth : null;
            self.weekInMonth = self.weekInMonth && self.weekInMonth > 0 ? self.weekInMonth : null;

            delete self.vmEditable;
            delete self.vmIndex;
            delete self.vmNew;

        };


        return Weekscheme;


    }
})();